module.exports = __webpack_public_path__ + "media/images/gboe_logo-f31161d837ece11f2672434d171ed2e7.png";